class HeaderSearchTrigger extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.handleClick = (e) => {
      e.preventDefault();
      this.dispatchEvent(
        new CustomEvent("header-search:open", { bubbles: true }),
      );
    };

    this.target = this.parentElement;

    this.target.addEventListener("click", this.handleClick);
  }

  disconnectedCallback() {
    this.target.removeEventListener("click", this.handleClick);
  }
}

if (!customElements.get("header-search-trigger")) {
  customElements.define("header-search-trigger", HeaderSearchTrigger);
}
